// import jsonHelper from "../../shared/jsonHelper";

export default {
  state: {
    isPrintViewHidden: true,
    isDesignViewHidden: true,
    isWarningsViewHidden: true,
    isGeometryDetailsViewHidden: true
  },
  getters: {
    printViewHidden: state => state.isPrintViewHidden,
    designViewHidden: state => state.isDesignViewHidden,
    warningsViewHidden: state => state.isWarningsViewHidden,
    geometryDetailsViewHidden: state => state.isGeometryDetailsViewHidden
  },
  mutations: {
    resetSubViewsProp(state) {
      state.isPrintViewHidden = true;
      state.isDesignViewHidden = true;
      state.isWarningsViewHidden = true;
      state.isGeometryDetailsViewHidden = true;
    },
    togglePrintViewHiddenProp(state) {
      state.isPrintViewHidden = !state.isPrintViewHidden;
      state.isDesignViewHidden = true;
      state.isWarningsViewHidden = true;
      state.isGeometryDetailsViewHidden = true;
    },
    toggleDesignViewHiddenProp(state) {
      state.isPrintViewHidden = true;
      state.isDesignViewHidden = !state.isDesignViewHidden;
      state.isWarningsViewHidden = true;
      state.isGeometryDetailsViewHidden = true;
    },
    toggleWarningsViewHiddenProp(state) {
      state.isPrintViewHidden = true;
      state.isDesignViewHidden = true;
      state.isWarningsViewHidden = !state.isWarningsViewHidden;
      state.isGeometryDetailsViewHidden = true;
    },
    toggleGeometryDetailsViewHiddenProp(state) {
      state.isPrintViewHidden = true;
      state.isDesignViewHidden = true;
      state.isWarningsViewHidden = true;
      state.isGeometryDetailsViewHidden = !state.isGeometryDetailsViewHidden;
    }
  },
  actions: {
    resetSubViews({ commit }) {
      commit("resetSubViewsProp");
    },
    togglePrintViewProperty({ commit }) {
      commit("togglePrintViewHiddenProp");
    },
    toggleDesignViewProperty({ commit }) {
      commit("toggleDesignViewHiddenProp");
    },
    toggleWarningsViewProperty({ commit }) {
      commit("toggleWarningsViewHiddenProp");
    },
    toggleGeometryDetailsViewProperty({ commit }) {
      commit("toggleGeometryDetailsViewHiddenProp");
    }
  }
};
